//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WxHeader from './Header'
import NewsList from './NewsList'
import WxFooter from './Footer'

export default {

  components: {
    WxHeader,
    WxFooter,
    NewsList,
  },
  data () {
    return {
      tag: '',
      index:0
    }
  },
  ready () {
  },
  methods:{
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.vue